<template>
    <div
        class="credit-score col-span-12 lg:col-span-6 bg-white dark:bg-slate-800 rounded-lg shadow dark:shadow-slate-900/50 overflow-hidden relative md:min-h-[400px]"
    >
        <div class="p-6 h-auto relative">
            <div class="flex justify-between items-center">
                <div class="flex items-center gap-2">
                    <icon icon="credit-score" class="text-slate-800 dark:text-slate-100" />
                    <span class="text-lg font-medium text-slate-800 dark:text-slate-100">
                        Credit score
                    </span>
                </div>
                <Link
                    href="/credit-score/"
                    class="link-base link-dark"
                    id="hs-dashboard-credit-score-details"
                >
                    View details
                    <icon icon="arrow" />
                </Link>
            </div>

            <div
                v-if="loadingUserCreditScore"
                class="relative h-64 flex items-center justify-center"
            >
                <LoadingState
                    :loading="true"
                    size="large"
                    :noBackground="true"
                />
            </div>
            <div
                v-else-if="
                    !userScoreData?.latest_score ||
                    userScoreData?.latest_score === 0
                "
            >
                <start-tracking
                    :onDashboard="onDashboard"
                    :hideHeader="true"
                ></start-tracking>
            </div>
            <div v-else>
                <div class="relative mx-auto max-w-md">
                    <CreditscoreMeter />
                    <div
                        v-if="showOutdatedWarning"
                        class="absolute left-1/2 transform -translate-x-1/2 translate-y-[-45px]"
                    >
                        <a
                            href="#"
                            class="btn-base btn-white h-9 px-4 py-2 rounded justify-start items-start gap-2 inline-flex text-sm font-medium text-slate-800 dark:text-slate-100 hover:text-slate-700 active:text-slate-700 focus:outline-none focus:ring-2 focus:ring-slate-300 focus:ring-offset-0"
                            @click.prevent="openCreditScoreModal"
                            role="button"
                            id="hs-dashboard-add-credit-score"
                        >
                            <div
                                class="w-5 h-5 justify-center items-center flex overflow-hidden"
                            >
                                <div
                                    class="w-5 h-5 relative flex-col justify-start items-start flex overflow-hidden"
                                >
                                    <Icon icon="plus" class="text-slate-800 dark:text-slate-100" />
                                </div>
                            </div>
                            <div
                                class="text-slate-800 dark:text-slate-100 text-sm font-medium font-['Inter'] leading-tight whitespace-nowrap"
                            >
                                Add credit score
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <credit-score-modal @close="closeCreditScoreModal" />
    </div>
</template>
<script>
import { Link } from '@inertiajs/vue3';
import { mapState, mapActions } from 'pinia';
import { useCreditScoreStore } from '@/store/creditscore';
import CreditscoreMeter from '@/charts/creditscore/meter.vue';
import CreditScoreModal from '@/components/creditscore/modals/credit-score.vue';
import StartTracking from '@/components/creditscore/start-tracking.vue';
import Icon from '@/components/ui/icon/icon.vue';
import LoadingState from '@/components/ui/loading-state/loading-state.vue';

export default {
    name: 'CreditScore',
    props: {
        onDashboard: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        Link,
        CreditscoreMeter,
        CreditScoreModal,
        StartTracking,
        Icon,
        LoadingState,
    },
    computed: {
        ...mapState(useCreditScoreStore, [
            'loadingUserCreditScore',
            'userScoreData',
            'activeUser',
        ]),
    },
    data() {
        return {
            isOutdated: false,
        };
    },
    methods: {
        ...mapActions(useCreditScoreStore, [
            'openCreditScoreModal',
            'closeCreditScoreModal',
        ]),
        updateOutdatedStatus(status) {
            this.isOutdated = status;
        },
        showOutdatedWarning() {
            return this.userScoreData?.last_updated_days > 60;
        },
    },
    created() {},
    mounted() {},
};
</script>
